import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { AiFillMail, AiFillPhone } from "react-icons/ai";
import { FiMenu, FiX } from "react-icons/fi";
import { MdKeyboardArrowDown } from "react-icons/md";

const Navbar = () => {
  const isDesktop = useMediaQuery({ query: "(min-width: 768px)" });
  // const [open, setOpen] = useState(!isDesktop);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleServicesDropdown = () =>
    setServicesDropdownOpen(!servicesDropdownOpen);

  const linkClass = ({ isActive }) =>
    `text-md font-medium ${
      isActive ? "text-orange-600" : "text-blue-700"
    } hover:text-orange-500`;

  useEffect(() => {
    // setOpen(!isDesktop);
    if (isDesktop) {
      setServicesDropdownOpen(false); // reset dropdown when switching to desktop
    }
  }, [isDesktop]);

  // const closeNavbar = () => {
  //   if (!isDesktop) setOpen(true);
  // };

  return (
    <header>
      {/* Top Contact Bar */}
      <div className="w-full px-5 mx-auto bg-[#002b46]">
        <div className="flex flex-col sm:flex-row justify-between items-center py-2 space-y-2 sm:space-y-0">
          {/* Email */}
          <Link
            to="mailto:stratusinst@gmail.com"
            className="text-orange-600 text-sm sm:text-md flex gap-2 items-center"
          >
            <AiFillMail />
            <span className="text-white hover:text-orange-400">
              stratusinst@gmail.com
            </span>
          </Link>

          {/* Phone Numbers */}
          <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-2 sm:space-y-0">
            <Link
              to="tel:+917400091415"
              className="text-white text-sm flex items-center hover:text-orange-400"
            >
              <AiFillPhone className="text-orange-600" />
              <span className="ml-2"> +91 74000 91415</span>
            </Link>
            {/* <Link
              to="tel:+919897630594"
              className="text-white text-sm flex items-center hover:text-orange-400"
            >
              <AiFillPhone className="text-orange-600" />
              <span className="ml-2">+91 97026 77357</span>
            </Link> */}
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <Link to="/">
            <img src="./img/service/rectlogo.png" alt="Logo" className="h-[90px] w-30" />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex flex-1 justify-center space-x-6 items-center">
            <NavLink to="/" className={linkClass}>
              Home
            </NavLink>
            <NavLink to="/about" className={linkClass}>
              About Us
            </NavLink>

            {/* Services Dropdown */}
            <div className="relative group">
              <button
                className="text-sm text-orange-600 font-semibold flex items-center hover:text-orange-800 md:hover:text-orange-800"
                onClick={toggleServicesDropdown}
              >
                Services <MdKeyboardArrowDown />
              </button>

              <div
                className={`absolute bg-white shadow-lg mt-1 py-2 w-40 z-10 ${
                  servicesDropdownOpen ? "block" : "hidden"
                } md:group-hover:block`}
              >
                <NavLink
                  to="/service1"
                  className="block px-4 py-2 text-sm hover:bg-gray-100"
                  onClick={() => setServicesDropdownOpen(false)}
                >
                  Mapping Services
                </NavLink>
                <NavLink
                  to="/calibrationInstruments"
                  className="block px-4 py-2 text-sm hover:bg-gray-100"
                  onClick={() => setServicesDropdownOpen(false)}
                >
                  Calibration
                </NavLink>
                <NavLink
                  to="/hvacservice"
                  className="block px-4 py-2 text-sm hover:bg-gray-100"
                  onClick={() => setServicesDropdownOpen(false)}
                >
                  HVAC Validation
                </NavLink>
                <NavLink
                  to="/otherservice"
                  className="block px-4 py-2 text-sm hover:bg-gray-100"
                  onClick={() => setServicesDropdownOpen(false)}
                >
                  Other Services
                </NavLink>
              </div>
            </div>

            <NavLink to="/client" className={linkClass}>
              Client
            </NavLink>
            <NavLink to="/contact" className={linkClass}>
              Contact
            </NavLink>
          </div>

          {/* Right CTA Button */}
          <div className="hidden md:block">
            <Link to="/contact">
            <button className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 text-sm font-semibold">
              Get In Touch →
            </button>
            </Link>
          </div>

          {/* Mobile Menu Icon */}
          <div className="md:hidden">
            <button onClick={toggleMenu}>
              {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden bg-white shadow-lg px-4 pt-4 pb-6 space-y-3 text-center">
            <Link
              to="/"
              className="block text-blue-700 text-sm font-medium"
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block text-blue-700 text-sm font-medium"
              onClick={() => setMenuOpen(false)}
            >
              About Us
            </Link>

            {/* Mobile Services Dropdown */}
            <div>
              <button
                className="text-orange-600 font-semibold text-sm flex justify-center items-center w-full"
                onClick={toggleServicesDropdown}
              >
                Services <MdKeyboardArrowDown />
              </button>
              {servicesDropdownOpen && (
                <div className="space-y-1 mt-1">
                  <Link
                    to="/service1"
                    className="block text-sm text-gray-700"
                    onClick={() => {
                      setServicesDropdownOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    Mapping Services
                  </Link>
                  <Link
                    to="/calibrationInstruments"
                    className="block text-sm text-gray-700"
                    onClick={() => {
                      setServicesDropdownOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    Calibration
                  </Link>
                  <Link
                    to="/hvacservice"
                    className="block text-sm text-gray-700"
                    onClick={() => {
                      setServicesDropdownOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    HVAC Validation
                  </Link>
                  <Link
                    to="/otherservice"
                    className="block text-sm text-gray-700"
                    onClick={() => {
                      setServicesDropdownOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    Other Services
                  </Link>
                </div>
              )}
            </div>
            <Link
              to="/client"
              className="block text-blue-700 text-sm font-medium"
              onClick={() => setMenuOpen(false)}
            >
              Client
            </Link>
            <Link
              to="/contact"
              className="block text-blue-700 text-sm font-medium"
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
              <Link to="/contact">
            <button className="w-full bg-orange-500 text-white mt-4 py-2 rounded font-semibold text-sm">
              Get In Touch →
            </button>
              </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
